const createQueryString = (queryParams: Record<string, string | undefined | null>): string => {
    const queryParamsWithoutEmptyValues = Object.keys(queryParams).reduce(
        (acc, key) => {
            if (queryParams[key]) acc[key] = queryParams[key]!;
            return acc;
        },
        {} as Record<string, string>,
    );

    const queryString = new URLSearchParams(queryParamsWithoutEmptyValues).toString();
    return queryString ? `?${queryString}` : '';
};

export const createQueryStringFormArray = (key: string, value: string[], isStartOfQueryString = true) => {
    const prefix = isStartOfQueryString ? '?' : '&';
    const queryString = new URLSearchParams();
    value.forEach((x) => queryString.append(key, x));
    return queryString.toString().length > 0 ? `${prefix}${queryString}` : '';
};

export default createQueryString;
